export const longPriceForOffices = (options) => {
  const price1 = options[0] ? options[0].price : 0
  const price2 = options[1] ? options[1].price : 0
  let priceStr = "N/A"
  if (price1) {
    priceStr = `$${price1.toLocaleString("en")}`
  } else {
    return priceStr
  }
  if (price2 && price1 !== price2) {
    priceStr += ` - $${price2.toLocaleString("en")}`
  }

  return priceStr
}

export const totalPriceForDesks = (options, seatCount = 1) => {
  const price1 = options[0] ? options[0].price * Number(seatCount) : 0
  const price2 = options[1] ? options[1].price * Number(seatCount) : 0
  let priceStr = "N/A"
  if (price1) {
    priceStr = `$${price1.toLocaleString("en")}`
  } else {
    return priceStr
  }
  if (price2 && price1 !== price2) {
    priceStr += ` - $${price2.toLocaleString("en")}`
  }

  return priceStr
}

export const pricePerDesk = (options) => {
  const price1 = options[0] ? options[0].price : 0
  const price2 = options[1] ? options[1].price : 0
  let priceStr = "N/A"
  if (price1) {
    priceStr = `$${price1.toLocaleString("en")}`
  } else {
    return priceStr
  }
  if (price2 && price1 !== price2) {
    priceStr += ` - $${price2.toLocaleString("en")}`
  }

  return priceStr
}
